import { Injectable } from '@angular/core';

const SCHEDULER_CLIENT_ID_KEY = 'SCHEDULER_HUBSPOT_CLIENT_ID';

/**
 * Servicio singleton que preserva el hubspotClientId durante las redirecciones de login.
 * Se limpia explícitamente al finalizar el flujo del agendador.
 */
@Injectable({ providedIn: 'root' })
export class SchedulerSessionService {

    /**
     * Guarda el ID del cliente de HubSpot en sessionStorage.
     * Sobrevive a redirecciones dentro de la misma pestaña.
     */
    saveClientId(hubspotClientId: string): void {
        sessionStorage.setItem(SCHEDULER_CLIENT_ID_KEY, hubspotClientId);
    }

    /**
     * Recupera el ID guardado. Devuelve null si no existe.
     */
    getClientId(): string | null {
        return sessionStorage.getItem(SCHEDULER_CLIENT_ID_KEY);
    }

    /**
     * Limpia el ID del cliente. Debe llamarse al finalizar el flujo
     * (en SchedulerSuccessScreenComponent al pulsar "Cerrar" o "Nueva Cita").
     */
    clearClientId(): void {
        sessionStorage.removeItem(SCHEDULER_CLIENT_ID_KEY);
    }

    /**
     * Indica si hay un flujo de agendador activo en esta pestaña.
     */
    hasActiveSchedulerSession(): boolean {
        return !!this.getClientId();
    }
}
